exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fp_step_title{color:#999}.fp_step{display:flex;justify-content:center;align-items:center;margin-bottom:10px}", ""]);

// exports
